import React from 'react';
import Card from './Card';

interface EmptyStateCardProps {
  icon?: string;
  title: string;
  message: string;
  action?: React.ReactNode;
  className?: string;
}

const EmptyStateCard: React.FC<EmptyStateCardProps> = ({
  icon = '📭',
  title,
  message,
  action,
  className = ''
}) => {
  return (
    <Card className={`text-center p-12 ${className}`}>
      <Card.Body>
        <div className="text-5xl mb-4">{icon}</div>
        <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-2">
          {title}
        </h3>
        <p className="text-gray-600 dark:text-gray-400">{message}</p>
        {action && <div className="mt-4">{action}</div>}
      </Card.Body>
    </Card>
  );
};

export default EmptyStateCard;
